import { Button, Checkbox, Spin, Steps } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
import { toast } from "react-toastify";
import FooterSecondary from "../../common-component/footer-secondary/FooterSecondary";
import img2 from "../../images/intelegain-white-logo.svg";
import {
  fetchCandidateByID,
  fetchCandidateDeclarationByID,
  updateCandidateDeclaration,
  updateCandidateFormDetails,
  updateCandidateSignature,
} from "../../redux-store/candidateSlicer";
import {
  addExperienceDetail,
  deleteExperienceDetail,
  fetchExperienceDetailByCandidateID,
  updateExperienceDetail,
} from "../../redux-store/experienceDetailSlicer";
import {
  addFamilyDetail,
  deleteFamilyDetail,
  fetchFamilyDetailByCandidateID,
  updateFamilyDetail,
} from "../../redux-store/familyDetailSlicer";
import {
  addQualification,
  deleteQualification,
  fetchQualificationByCandidateID,
  updateQualification,
} from "../../redux-store/qualificationSlicer";
import {
  addReference,
  deleteReference,
  fetchReferenceByCandidateID,
  updateReference,
} from "../../redux-store/referenceSlicer";
import candidateService from "../../service-api/candidateService";
import "./candidate-form.scss";
import Declaration from "./Declaration";
import {
  qualificationsInitialValues,
  experienceDetailsInitialValues,
  familyDetailsInitialValues,
  initialValues,
  knowAboutUsRadios,
  referencesInitialArray,
} from "./enum";
import FamilyDetailTable from "./FamilyDetailTable";
import FormSubmitted from "./FormSubmitted";
import QualificationTable from "./QualificationTable";
import ReferenceTable from "./ReferenceTable";
import TotalExperienceTable from "./TotalExperienceTable";
import MobilePhotoTaker from "./CaptureImage/MobilePhotoTaker";

const CandidateForm = ({ isLoggedIn, candidateId }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const { singleCandidate, declarationData } = useSelector(
    (state) => state.candidates
  );
  const qualification = useSelector((state) => state.qualification);
  const experienceDetail = useSelector((state) => state.experienceDetail);
  const familyDetail = useSelector((state) => state.familyDetail);
  const reference = useSelector((state) => state.reference);
  const [loading, setLoading] = useState({ page: false, form: false });
  const [formData, setFormData] = useState(initialValues);
  const [declarationFormData, setDeclarationFormData] = useState({
    itl_declarationname: "",
    itl_declarationdate: "",
    itl_declarationplace: "",
    itl_declarationsignature: "",
  });
  const [signature, setSignature] = useState(null);
  const [qualifications, setQualifications] = useState({
    data: [qualificationsInitialValues, qualificationsInitialValues],
    deletedData: [],
  });
  const [experienceDetails, setExperienceDetails] = useState({
    data: [experienceDetailsInitialValues, experienceDetailsInitialValues],
    deletedData: [],
  });
  const [familyDetails, setFamilyDetails] = useState({
    data: [familyDetailsInitialValues],
    deletedData: [],
  });
  const [references, setReferences] = useState({
    data: referencesInitialArray,
    deletedData: [],
  });
  const [isAddressSame, setIsAddressSame] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [showPhotoTaker, setShowPhotoTaker] = useState(isMobile);

  const handleChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const processDetails = async ({
    data,
    deletedData,
    idField,
    updateAction,
    addAction,
    deleteAction,
    getPayload,
    bindCandidate = false,
  }) => {
    for (const detail of data) {
      if (detail[idField]) {
        await dispatch(
          updateAction({ id: detail[idField], formData: getPayload(detail) })
        );
      } else {
        await dispatch(
          addAction({
            ...getPayload(detail),
            ...(bindCandidate && {
              "itl_CandidateID@odata.bind": `/contacts(${candidateId})`,
            }),
          })
        );
      }
    }

    for (const id of deletedData) {
      await dispatch(deleteAction(id));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (current === 0) {
      // Form details
      if (!formData.lastname?.trim()) newErrors.lastname = "Required";
      if (!formData.itl_dateofbirth?.trim())
        newErrors.itl_dateofbirth = "Required";

      const contact = String(formData.itl_candidatecontact || "").trim();
      if (!contact) {
        newErrors.itl_candidatecontact = "Required";
      } else if (contact.length < 10) {
        newErrors.itl_candidatecontact = "Invalid contact";
      }

      const alternateContact = String(
        formData.itl_alternatecontact || ""
      ).trim();
      if (!alternateContact) {
        newErrors.itl_alternatecontact = "Required";
      } else if (alternateContact.length < 10) {
        newErrors.itl_alternatecontact = "Invalid contact";
      }

      if (!formData.itl_presentaddress?.trim())
        newErrors.itl_presentaddress = "Required";
      if (!formData.itl_permanentaddress?.trim())
        newErrors.itl_permanentaddress = "Required";
    } else if (current === 1) {
      // Qualification Validation
      const qualificationErrors = qualifications.data.map((q, index) => {
        const qualError = {};
        if (!q.itl_name?.trim()) qualError.itl_name = "Required";
        if (!q.itl_institutename?.trim())
          qualError.itl_institutename = "Required";
        // if (!q.itl_address?.trim()) qualError.itl_address = "Required";
        if (
          q.itl_year === null ||
          q.itl_year === undefined ||
          q.itl_year === ""
        ) {
          qualError.itl_year = "Required";
        }

        // if (!q.itl_classdivision?.trim())
        //   qualError.itl_classdivision = "Required";
        if (!q.itl_marksobtained?.trim())
          qualError.itl_marksobtained = "Required";
        return Object.keys(qualError).length ? qualError : null;
      });

      if (qualificationErrors.some((err) => err !== null)) {
        newErrors.qualifications = qualificationErrors;
      }
    } else if (current === 2) {
      // Total Experience Validation
      const experienceErrors = experienceDetails.data.map((exp, index) => {
        const expError = {};
        if (!exp.itl_name?.trim()) expError.itl_name = "Required";
        if (!exp.itl_designation?.trim()) expError.itl_designation = "Required";
        if (
          exp.itl_salarydrawn === null ||
          exp.itl_salarydrawn === undefined ||
          exp.itl_salarydrawn === ""
        )
          expError.itl_salarydrawn = "Required";

        if (!exp.itl_periodfrom?.trim()) expError.itl_periodfrom = "Required";
        if (!exp.itl_periodto?.trim()) expError.itl_periodto = "Required";
        // if (!exp.itl_address?.trim()) expError.itl_address = "Required";
        // if (!exp.itl_reasonforleaving?.trim())
        //   expError.itl_reasonforleaving = "Required";
        return Object.keys(expError).length ? expError : null;
      });

      if (experienceErrors.some((err) => err !== null)) {
        newErrors.totalExperience = experienceErrors;
      }
    } else if (current === 3) {
      // Family Details Validation
      const familyErrors = familyDetails.data.map((member, index) => {
        const memberError = {};
        if (!member.itl_name?.trim()) memberError.itl_name = "Required";
        if (
          member.itl_relation === null ||
          member.itl_relation === undefined ||
          member.itl_relation === ""
        )
          memberError.itl_relation = "Required";
        if (!member.itl_profession?.trim())
          memberError.itl_profession = "Required";
        return Object.keys(memberError).length ? memberError : null;
      });

      if (familyErrors.some((err) => err !== null)) {
        newErrors.familyDetails = familyErrors;
      }
    } else if (current === 4) {
      // References Validation
      const referenceErrors = references.data.map((ref, index) => {
        const refError = {};
        // if (!ref.itl_relationship?.trim()) refError.itl_relationship = "Required";
        // if (ref.itl_reference === null || ref.itl_reference === undefined)
        //   refError.itl_reference = "Required";

        const contact = String(ref.itl_contact || "").trim();
        if (!contact) {
          refError.itl_contact = "Required";
        } else if (contact.length < 10) {
          refError.itl_contact = "Invalid contact";
        }

        if (!ref.itl_name?.trim()) refError.itl_name = "Required";
        // if (!ref.itl_address?.trim()) refError.itl_address = "Required";
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!ref.itl_email?.trim()) refError.itl_email = "Required";
        else if (!emailRegex.test(ref.itl_email)) {
          refError.itl_email = "Invalid email format";
        }
        return Object.keys(refError).length ? refError : null;
      });

      if (referenceErrors.some((err) => err !== null)) {
        newErrors.references = referenceErrors;
      }
    } else if (current === 5) {
      const knowAboutUsSource = Number(formData.itl_knowaboutussource);

      if (!knowAboutUsSource) {
        newErrors.itl_knowaboutussource = "Required";
      }

      if (knowAboutUsSource === 5) {
        if (!formData.itl_consultantname?.trim()) {
          newErrors.itl_consultantname = "Required";
        }
      }

      if (knowAboutUsSource === 6) {
        if (!formData.itl_otherspecification?.trim()) {
          newErrors.itl_otherspecification = "Required";
        }
      }
    } else if (current === 6) {
      // Declaration Form Details
      if (!declarationFormData.itl_declarationdate?.trim())
        newErrors.itl_declarationdate = "Required";
      if (!declarationFormData.itl_declarationname?.trim())
        newErrors.itl_declarationname = "Required";
      if (!declarationFormData.itl_declarationplace?.trim())
        newErrors.itl_declarationplace = "Required";
      if (!signature) newErrors.itl_declarationsignature = "Required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }
    setLoading((prev) => ({ ...prev, form: true }));
    try {
      if (current === 0) {
        await dispatch(
          updateCandidateFormDetails({
            id: candidateId,
            formData: {
              lastname: formData.lastname,
              itl_candidatecontact: formData.itl_candidatecontact,
              itl_alternatecontact: formData.itl_alternatecontact,
              itl_presentaddress: formData.itl_presentaddress,
              itl_permanentaddress: formData.itl_permanentaddress,
              itl_dateofbirth: formData.itl_dateofbirth,
            },
          })
        );
        await dispatch(fetchCandidateByID(candidateId));
        toast.info("Candidate details saved");
      } else if (current === 1) {
        await processDetails({
          data: qualifications.data,
          deletedData: qualifications.deletedData,
          idField: "itl_qualificationid",
          updateAction: updateQualification,
          addAction: addQualification,
          deleteAction: deleteQualification,
          getPayload: (d) => ({
            itl_name: d.itl_name,
            itl_institutename: d.itl_institutename,
            itl_address: d.itl_address,
            itl_year: d.itl_year,
            itl_marksobtained: d.itl_marksobtained,
            itl_classdivision: d.itl_classdivision,
          }),
          bindCandidate: true,
        });
        await dispatch(fetchQualificationByCandidateID(candidateId));
        toast.info("Qualification details saved!");
      } else if (current === 2) {
        await processDetails({
          data: experienceDetails.data,
          deletedData: experienceDetails.deletedData,
          idField: "itl_experiencedetailid",
          updateAction: updateExperienceDetail,
          addAction: addExperienceDetail,
          deleteAction: deleteExperienceDetail,
          getPayload: (d) => ({
            itl_name: d.itl_name,
            itl_periodfrom: d.itl_periodfrom,
            itl_periodto: d.itl_periodto,
            itl_designation: d.itl_designation,
            itl_reasonforleaving: d.itl_reasonforleaving,
            itl_salarydrawn: d.itl_salarydrawn,
            itl_address: d.itl_address,
          }),
          bindCandidate: true,
        });
        await dispatch(fetchExperienceDetailByCandidateID(candidateId));
        toast.info("Experience details saved");
      } else if (current === 3) {
        await processDetails({
          data: familyDetails.data,
          deletedData: familyDetails.deletedData,
          idField: "itl_familydetailid",
          updateAction: updateFamilyDetail,
          addAction: addFamilyDetail,
          deleteAction: deleteFamilyDetail,
          getPayload: (d) => ({
            itl_name: d.itl_name,
            itl_relation: d.itl_relation,
            itl_profession: d.itl_profession,
          }),
          bindCandidate: true,
        });
        await dispatch(fetchFamilyDetailByCandidateID(candidateId));
        toast.info("Family details saved");
      } else if (current === 4) {
        await processDetails({
          data: references.data,
          deletedData: references.deletedData,
          idField: "itl_referenceid",
          updateAction: updateReference,
          addAction: addReference,
          deleteAction: deleteReference,
          getPayload: (d) => ({
            itl_name: d.itl_name,
            itl_contact: d.itl_contact,
            itl_email: d.itl_email,
            itl_address: d.itl_address,
            itl_relationship: d.itl_relationship,
            itl_reference: d.itl_reference,
          }),
          bindCandidate: true,
        });
        await dispatch(fetchReferenceByCandidateID(candidateId));
        toast.info("Reference details saved");
      } else if (current === 5) {
        await dispatch(
          updateCandidateFormDetails({
            id: candidateId,
            formData: {
              itl_knowaboutussource: formData.itl_knowaboutussource,
              itl_consultantname: formData.itl_consultantname || null,
              itl_otherspecification: formData.itl_otherspecification || null,
            },
          })
        );

        await dispatch(fetchCandidateByID(candidateId));
        toast.info("Details saved");
      } else if (current === 6) {
        await dispatch(
          updateCandidateDeclaration({
            id: candidateId,
            formData: {
              itl_declarationname: declarationFormData.itl_declarationname,
              itl_declarationdate: declarationFormData.itl_declarationdate,
              itl_declarationplace: declarationFormData.itl_declarationplace,
              itl_declarationsignature:
                declarationFormData.itl_declarationsignature,
            },
          })
        );

        await dispatch(
          updateCandidateSignature({
            id: candidateId,
            signatureFile: signature,
          })
        );

        await dispatch(
          updateCandidateFormDetails({
            id: candidateId,
            formData: {
              itl_formsubmitted: true,
            },
          })
        );
        toast.info("Recruitment form submitted!");
        sessionStorage.clear();
        navigate("/success", { replace: true });
      }

      await dispatch(fetchCandidateByID(candidateId));
    } finally {
      setLoading((prev) => ({ ...prev, form: false }));
      if (current !== 6) {
        setCurrent(current + 1);
      }
    }
  };

  useEffect(() => {
    if (qualification.data.length > 0) {
      setQualifications((prev) => ({
        ...prev,
        data: qualification.data,
      }));
    }
    if (experienceDetail.data.length > 0) {
      setExperienceDetails((prev) => ({
        ...prev,
        data: experienceDetail.data,
      }));
    }
    if (familyDetail.data.length > 0) {
      setFamilyDetails((prev) => ({
        ...prev,
        data: familyDetail.data,
      }));
    }
    if (reference.data.length > 0) {
      setReferences((prev) => ({
        ...prev,
        data: reference.data,
      }));
    }
  }, [
    qualification.data,
    experienceDetail.data,
    familyDetail.data,
    reference.data,
  ]);

  useEffect(() => {
    if (singleCandidate) {
      setFormData({
        lastname: singleCandidate.lastname || "",
        itl_candidatecontact: singleCandidate.itl_candidatecontact || "",
        itl_alternatecontact: singleCandidate.itl_alternatecontact || "",
        // itl_bloodgroup: singleCandidate.itl_bloodgroup || "",
        itl_presentaddress: singleCandidate.itl_presentaddress || "",
        itl_permanentaddress: singleCandidate.itl_permanentaddress || "",
        itl_dateofbirth: singleCandidate.itl_dateofbirth || "",
        itl_knowaboutussource: singleCandidate.itl_knowaboutussource || "",
        itl_consultantname: singleCandidate.itl_consultantname || "",
        itl_otherspecification: singleCandidate.itl_otherspecification || "",
      });
    }
  }, [singleCandidate]);

  useEffect(() => {
    if (declarationData) {
      setDeclarationFormData({
        itl_declarationname: declarationData.itl_declarationname || "",
        itl_declarationdate: declarationData.itl_declarationdate || "",
        itl_declarationplace: declarationData.itl_declarationplace || "",
        itl_declarationsignature:
          declarationData.itl_declarationsignature || "",
      });
    }
  }, [declarationData]);

  useEffect(() => {
    if (candidateId) {
      const getTokenAndFetchCandidate = async () => {
        setLoading((prev) => ({ ...prev, page: true }));
        try {
          await candidateService.getCandidateFeedbackToken();
          await dispatch(fetchQualificationByCandidateID(candidateId));
          await dispatch(fetchCandidateByID(candidateId));
          await dispatch(fetchExperienceDetailByCandidateID(candidateId));
          await dispatch(fetchFamilyDetailByCandidateID(candidateId));
          await dispatch(fetchCandidateDeclarationByID(candidateId));
          await dispatch(fetchReferenceByCandidateID(candidateId));
          const response = await candidateService.getDeclarationSignature(
            candidateId
          );
          setSignature(response);
        } catch (error) {
          console.error(
            "Error getting token or fetching candidate data:",
            error
          );
        } finally {
          setLoading((prev) => ({ ...prev, page: false }));
        }
      };

      getTokenAndFetchCandidate();
    }
  }, [candidateId]);

  useEffect(() => {
    if (isAddressSame) {
      setFormData((prev) => ({
        ...prev,
        itl_permanentaddress: formData.itl_presentaddress,
      }));
    }
  }, [isAddressSame]);

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  return (
    <div className="overflow-y-auto vh-100 custom-form">
      <header className="msq-bg-dark-blue py-3">
        <Container>
          <img src={img2} />
        </Container>
      </header>
      {loading.page ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spin />
        </div>
      ) : (
        <React.Fragment>
          {singleCandidate.itl_formsubmitted && !isLoggedIn ? (
            <FormSubmitted />
          ) : showPhotoTaker ? (
            <MobilePhotoTaker
              setShowPhotoTaker={setShowPhotoTaker}
              candidateId={candidateId}
            />
          ) : (
            <section className="py-5 bg-light-2 candidate-form-container">
              <Container>
                <h2 className="mb-5 text-center">
                  {/* Hello {singleCandidate?.lastname || "Candidate"}, please fill
                  in your details */}
                  Recruitment Form
                </h2>
                <div className="mb-5">
                  <Steps
                    direction="horizontal"
                    size="small"
                    current={current}
                    items={[{}, {}, {}, {}, {}, {}, {}]}
                    className="custom-steps"
                  />
                </div>

                {current === 0 && (
                  <div className="p-4 bg-white rounded-3 mb-4">
                    <h3>Candidate Details</h3>
                    <hr />
                    <Row>
                      <Col md={6} sm={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required fw-semibold">
                            Candidate Name
                          </Form.Label>
                          <Form.Control
                            className={`${errors.lastname ? "error" : ""}`}
                            type="text"
                            placeholder="Name"
                            value={formData.lastname}
                            onChange={(e) =>
                              handleChange("lastname", e.target.value)
                            }
                            disabled={loading.form}
                          />
                          <div className="input-error">{errors.lastname}</div>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">
                            Date of Birth
                          </Form.Label>
                          <Form.Control
                            type="date"
                            className={`${
                              errors.itl_dateofbirth ? "error" : ""
                            }`}
                            value={formData.itl_dateofbirth?.slice(0, 10)} // ensures value is in YYYY-MM-DD format
                            onChange={(e) => {
                              const formattedDate = dayjs(
                                e.target.value
                              ).format("YYYY-MM-DD");
                              handleChange("itl_dateofbirth", formattedDate);
                            }}
                            disabled={loading.form}
                          />

                          <div className="input-error">
                            {errors.itl_dateofbirth}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required fw-semibold">
                            Mobile Number{" "}
                          </Form.Label>
                          <Form.Control
                            className={` ${
                              errors.itl_candidatecontact ? "error" : ""
                            }`}
                            type="number"
                            placeholder="Mobile Number"
                            value={formData.itl_candidatecontact}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleChange(
                                "itl_candidatecontact",
                                value.slice(0, 10)
                              );
                            }}
                            disabled={loading.form}
                          />
                          <div className="input-error">
                            {errors.itl_candidatecontact}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required fw-semibold">
                            Alternate Mobile Number{" "}
                          </Form.Label>
                          <Form.Control
                            className={` ${
                              errors.itl_alternatecontact ? "error" : ""
                            }`}
                            type="number"
                            placeholder="Alternate Mobile Number"
                            value={formData.itl_alternatecontact}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleChange(
                                "itl_alternatecontact",
                                value.slice(0, 10)
                              );
                            }}
                            disabled={loading.form}
                          />
                          <div className="input-error">
                            {errors.itl_alternatecontact}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required fw-semibold">
                            Present Address
                          </Form.Label>
                          <Form.Control
                            as={"textarea"}
                            className={`${
                              errors.itl_presentaddress ? "error" : ""
                            }`}
                            type="text"
                            placeholder="Present Address"
                            value={formData.itl_presentaddress}
                            onChange={(e) =>
                              handleChange("itl_presentaddress", e.target.value)
                            }
                            disabled={loading.form}
                          />
                          <div className="input-error">
                            {errors.itl_presentaddress}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group className="">
                          <Form.Label className="required fw-semibold">
                            Permanent Address
                          </Form.Label>
                          <Form.Control
                            as={"textarea"}
                            className={`${
                              errors.itl_permanentaddress ? "error" : ""
                            }`}
                            placeholder="Permanent Address"
                            value={formData.itl_permanentaddress}
                            onChange={(e) => {
                              handleChange(
                                "itl_permanentaddress",
                                e.target.value
                              );
                            }}
                            disabled={loading.form || isAddressSame}
                          />
                          <div className="input-error">
                            {errors.itl_permanentaddress}
                          </div>
                          <div className="d-flex justify-content-end mt-3">
                            <Checkbox
                              checked={isAddressSame}
                              onChange={(e) =>
                                setIsAddressSame(e.target.checked)
                              }
                            >
                              Same as{" "}
                              <span className="fw-semibold">
                                Present Address
                              </span>
                            </Checkbox>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                )}

                {current === 1 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <QualificationTable
                      errors={errors.qualifications || []}
                      details={qualifications}
                      setDetails={setQualifications}
                      loading={loading.form}
                    />
                  </div>
                )}

                {current === 2 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <TotalExperienceTable
                      errors={errors.totalExperience || []}
                      details={experienceDetails}
                      setDetails={setExperienceDetails}
                      loading={loading.form}
                    />
                  </div>
                )}

                {current === 3 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <FamilyDetailTable
                      errors={errors.familyDetails || []}
                      details={familyDetails}
                      setDetails={setFamilyDetails}
                      loading={loading.form}
                    />
                  </div>
                )}

                {current === 4 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <ReferenceTable
                      errors={errors.references || []}
                      details={references}
                      setDetails={setReferences}
                      loading={loading.form}
                    />
                  </div>
                )}

                {current === 5 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-end gap-1 gap-lg-2">
                      <h5 className="mb-0">
                        {" "}
                        How did you know about this job opening?{" "}
                      </h5>
                      <div className="custom-font-size">(Please select)</div>
                    </div>
                    <hr />
                    <Row>
                      {knowAboutUsRadios.map((item, index) => (
                        <Col key={index} className="mb-3 mb-lg-0" md={4} lg={2}>
                          <Form.Check
                            inline
                            label={item.label}
                            name="group1"
                            type="radio"
                            id={`radio-${index}`}
                            value={item.value}
                            checked={
                              formData.itl_knowaboutussource === item.value
                            }
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                itl_knowaboutussource: Number(e.target.value),
                              }))
                            }
                          />

                          {/* Show input only if this is Consultant (5) or Others (6) AND selected */}
                          {formData.itl_knowaboutussource === 5 &&
                            item.value === 5 && (
                              <div>
                                <Form.Control
                                  type="text"
                                  className={`${
                                    errors.itl_consultantname ? "error" : ""
                                  } mt-2`}
                                  value={formData.itl_consultantname}
                                  placeholder="Enter Consultant Name"
                                  onChange={(e) =>
                                    handleChange(
                                      "itl_consultantname",
                                      e.target.value
                                    )
                                  }
                                  disabled={loading.form}
                                />
                                <div className="input-error">
                                  {errors?.itl_consultantname}
                                </div>
                              </div>
                            )}

                          {formData.itl_knowaboutussource === 6 &&
                            item.value === 6 && (
                              <div>
                                <Form.Control
                                  type="text"
                                  className={`${
                                    errors.itl_otherspecification ? "error" : ""
                                  } mt-2`}
                                  value={formData.itl_otherspecification}
                                  placeholder="Please Specify"
                                  onChange={(e) =>
                                    handleChange(
                                      "itl_otherspecification",
                                      e.target.value
                                    )
                                  }
                                  disabled={loading.form}
                                />
                                <div className="input-error">
                                  {errors?.itl_otherspecification}
                                </div>
                              </div>
                            )}
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}

                {current === 6 && (
                  <div className="p-4 bg-white rounded-3 mb-4 custom-border-gray">
                    <Declaration
                      errors={errors}
                      declarationFormData={declarationFormData}
                      signature={signature}
                      setSignature={setSignature}
                      setDeclarationFormData={setDeclarationFormData}
                      loading={loading.form}
                    />
                  </div>
                )}

                <div className="d-flex justify-content-center">
                  <React.Fragment>
                    {current > 0 && (
                      <Button
                        size="large"
                        className="me-3"
                        onClick={() => setCurrent(current - 1)}
                        disabled={loading.form}
                      >
                        Previous
                      </Button>
                    )}
                    {current !== 6 && (
                      <Button
                        type="primary"
                        size="large"
                        onClick={handleSubmit}
                        loading={loading.form}
                        disabled={loading.form}
                        className="btn-blue border-none"
                      >
                        Next
                      </Button>
                    )}
                  </React.Fragment>
                  {current === 6 && (
                    <Button
                      size="large"
                      type="primary"
                      onClick={handleSubmit}
                      loading={loading.form}
                      className="me-3 btn-blue border-none"
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </Container>
            </section>
          )}
        </React.Fragment>
      )}
      <FooterSecondary />
    </div>
  );
};

export default CandidateForm;
